import { render, staticRenderFns } from "./detail_accountManage.vue?vue&type=template&id=6d46f681&scoped=true"
import script from "./detail_accountManage.vue?vue&type=script&lang=js"
export * from "./detail_accountManage.vue?vue&type=script&lang=js"
import style0 from "./detail_accountManage.vue?vue&type=style&index=0&id=6d46f681&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d46f681",
  null
  
)

export default component.exports